import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationDataProvider } from '../configuration-data-provider';
import { SharedDataProvider } from '../shared-data-provider';
import {Vendor} from '../dto/vendor';

/*
  Generated class for the VendorProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class VendorProvider {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient, private config: ConfigurationDataProvider, private shared: SharedDataProvider) { }


  /**
   * List all vendors which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.vendorURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(vendor : Vendor) {
    console.log('Push vendor to insert method of service.');
    vendor.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(vendor));
    return this.http.post(this.config.vendorURL+"new", JSON.stringify(vendor), {headers: this.headers});
  }

  public update(vendor : Vendor) {
    console.log('Push vendor to insert method of service.');
    vendor.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(vendor));
    return this.http.put(this.config.vendorURL+"id/"+vendor.id, JSON.stringify(vendor), {headers: this.headers});
  }

  public qryVendor(id : number) {
    return this.http.post(this.config.vendorURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete vendor '+ id);
    return this.http.post(this.config.vendorURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// ./src/providers/vendor/vendor.ts